module.exports = __webpack_public_path__ + "static/fond-menu-mobile-4bf3ff0878330654de25fc40a995a742.png";